// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function useDisplayVariantBy(param) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, config.categories);
  var sortByCategory = Belt_Option.map(Belt_Option.flatMap(activeCategory, Category$Showside.ExternalConnection.getStoreCategoryConnection), function (connection) {
    return connection.sortBy;
  });
  var appliedSort = Belt_Option.orElse(match$1.productSort, sortByCategory);
  if (appliedSort === undefined) {
    return config.settings.displayVariantBy;
  }
  switch (appliedSort) {
    case /* Default */0:
    case /* Featured */1:
    case /* BestSellers */2:
    case /* Newest */3:
      return config.settings.displayVariantBy;
    case /* HighestPrice */4:
      return /* HighestPriceVariant */1;
    case /* LowestPrice */5:
      return /* LowestPriceVariant */2;
    case /* HighestDiscount */6:
      return /* HighestDiscountVariant */3;
  }
}
export { useDisplayVariantBy };
/* Category-Showside Not a pure module */